import styled from 'styled-components'

export const StyledNewsAlertEditButton = styled.div``
